import TooltipContent from '../utilities/tooltip'

if (!Shopify.designMode) {
  const showEvents = ["mouseenter", "focus"]
  const hideEvents = ["mouseleave", "blur"]

  document.querySelectorAll(".main-article a").forEach((button) => {
    const href = button.getAttribute("href")
    if (href)
      if (href.indexOf(window.routes.shop_domain + "/products/") > -1) {
        const productHandle = href.split("/products/")[1].replace("/", "")
        const tooltip = document.getElementById(productHandle)
        if (tooltip) {
          showEvents.forEach((event) => {
            button.addEventListener(event, (e) => tooltip.show(e.target))
          })

          hideEvents.forEach((event) => {
            button.addEventListener(event, (e) => {
              if (!e.relatedTarget.closest(`tooltip-content#${tooltip.id}`)) {
                tooltip.hide()
              }
            })
          })
        }
      }
  })
}
